import {
  ModelPsAgreementRequests,
  ModelPsAgreementTemplate,
} from '../../models/fireModels/types'
import { AgreementFlowDefinitionValueSectionByIdItem } from '../AgreementFlowDefinitionInput/AgreementFlowDefinitionInputService'
import {
  AgreementFlowService,
  AgreementFlowServiceConstructor,
} from './AgreementFlowService'

const callbackOnAgreementCompletedDefault = async (service: AgreementFlowService) => {
  // 同意が finish したときに呼び出す関数
  // ここで同意を送信する処理を行う
  // `ps_agreement_requests` に対して 保存処理を実施
  const userInputtedValues = service.userInputtedValues
  const pkey = service?.agreementRequest?.pkey as string
  const apiPath = `/public/c/psag/completeAgreement?pkey=${pkey}`
  try {
    const res = await $core.$d.transport.post(apiPath, {
      user_inputted_values: userInputtedValues,
    })
  } catch (e) {
    $core.$toast.errorToast('同意の送信に失敗しました')
    throw e
  }
}

/**
 * 同意依頼を元に同意フローを初期化するための引数を生成する
 * @param agreementRequest
 */
export const initAgreementFlowServiceConstructorArgsWithAgreementRequest = (
  agreementRequest: ModelPsAgreementRequests,
): AgreementFlowServiceConstructor => {
  return {
    agreementRequestId: agreementRequest.id as number,
    flowPagesAndVariables: extractFlowPagesAndVariablesFromAgreementRequest(
      agreementRequest,
    ),
    userInputtedValues: agreementRequest.user_inputted_values || {},
    lockUserInputs: !!agreementRequest.completed_at,
    callbackOnAgreementCompleted: callbackOnAgreementCompletedDefault,
    agreementVariables: {
      agreementRequest: agreementRequest,
    },
    currentPageIndex: 0,
  }
}

export const initAgreementFlowServiceConstructorArgsWithAgreementTemplate = (
  agreementTemplate: ModelPsAgreementTemplate,
  agreementRequest?: Partial<ModelPsAgreementRequests>,
): AgreementFlowServiceConstructor => {
  return {
    agreementRequestId: undefined,
    flowPagesAndVariables: extractFlowPagesAndVariablesFromAgreementRequest({
      agreement_content: agreementTemplate.agreement_content,
    }),
    userInputtedValues: {},
    lockUserInputs: false,
    callbackOnAgreementCompleted: async () => {
      $core.$toast.success('プレビュー画面です。')
    },
    agreementVariables: {
      agreementTemplate: agreementTemplate,
      agreementRequest: agreementRequest,
    },
    currentPageIndex: 0,
  }
}

/**
 * 同意依頼からフローページと変数を抽出する
 * @param agreementRequest
 */
const extractFlowPagesAndVariablesFromAgreementRequest = (
  agreementRequest: Pick<ModelPsAgreementRequests, 'agreement_content'>,
): AgreementFlowServiceConstructor['flowPagesAndVariables'] => {
  // セクションをソートしておく
  const sections = Object.values(
    agreementRequest?.agreement_content?.sectionById || {},
  ).sort(
    (a, b) => (a.section.order || 0) - (b.section.order || 0),
  ) as AgreementFlowDefinitionValueSectionByIdItem[]
  // セクション内のテンプレートを抽出して、flowPages と flowVariables を生成する
  return sections.reduce((flowPagesAndVariables, section) => {
    // 除外であれば skip
    if (section.excluded) {
      return flowPagesAndVariables
    }
    // 1. 該当 section 内から、選択されている templates を抽出する
    const selectedTemplates = Object.values(section.selectableTemplateById).filter(
      template => template.selected,
    )
    // 2. 抽出した templates から、flowPages と flowVariables を生成する
    selectedTemplates.forEach(template => {
      const flowPages = (template.template.flow_pages || []).sort(
        (a, b) => (a.order || 0) - (b.order || 0),
      )
      flowPagesAndVariables.push({
        flowPages,
        flowVariables: template.userDefineItemsByKey,
      })
    })
    return flowPagesAndVariables
  }, [] as AgreementFlowServiceConstructor['flowPagesAndVariables'])
}
